<template>
  <div>
    <!-- 公共头 -->
    <hhead></hhead>
    <nnav></nnav>
    <div class="bgimg">
      <div class="userlist">
        <div class="list_head">
          <!-- 搜索 -->
          <div class="topTitle" style="margin-left: 40px;padding: 8px 0  ;">
            <img
              style="margin-right: 8px;"
              src="../../../assets/images/dh111.png"
              alt=""
            />
            <span style="font-size: 14px;color: #2C2F37;">模拟测试</span
            ><span style="color: #868E99;font-size: 14px;"
              >&nbsp;>&nbsp;模拟账户申请</span
            >
          </div>

          <!-- 模拟账户申请 -->
          <div class="contnet" :style="{minHeight:MHeight}" v-if="!type ? true : false">
            <!-- 注意事项 -->
            <div class="matter">
              <p>
                注意事项：<br />

                1.模拟账户申请后会自动审批，显示已生效即可使用（初始密码与账号一致）；<br />
                2.模拟账号审核通过后使用期限为30天（30天后账号将自动冻结，60天后数据将自动删除）；<br />
                3.每位用户只能同时申请或者使用5个模拟账户。<br />
              </p>
            </div>
            <div class="search">
              <div class="h_btn">
                <el-button
                  icon="el-icon-plus"
                  style="width:auto;"
                  type="primary"
                  @click="added"
                  >申请模拟账户</el-button
                >
              </div>

              <!-- <label class="yunName">
                <span @mousedown="yun">{{
                  yun_name ? yun_name : yun_name1
                }}</span
                ><i @click="yun" class="el-icon-caret-bottom"></i>
                <transition name="el-fade-in-linear">
                  <div class="yunName_select" v-show="yunName">
                    <input type="text" @blur="inp_blur" />
                    <li>未找到结果</li>
                  </div>
                </transition>
              </label> -->
              <label class="yunName"  :style="{border:focus_account1}">
                <input
                  type="text"
                  @focus="focus_account"
                 
                  @blur="blur_account"
                  v-model="account"
                  placeholder="模拟账号"
                />
              </label>
              <label class="yunName" :style="{border:focus_name1}">
                <input
                  type="text"
                  @focus="focus_name"
                  @blur="blur_name"
                  v-model="name"
                  placeholder="申请机构"
                />
              </label>
              <label class="yunName" :style="{border:accountAdd1}">
                <span @mousedown="accountAdd" ref="mbMenu" :style="{color:!accountType?'#868E99':''}">{{
                  accountType ? accountType : '账号状态'
                }}</span
                ><img class="img_" v-show=!accountTypeShow @click="accountAdd" src="../../../assets/images/bottom.png"></img>
                <img class="img_" v-show="accountTypeShow" @click="accountAdd" src="../../../assets/images/shang.png"></img>
                <transition name="el-fade-in-linear">
                  <div class="yunName_select" v-show="accountTypeShow">
                    <p
                      v-for="(item, index) in accountTypeList"
                      :key="index"
                      @mousedown="accountTypeAdd(item)"
                    >
                      {{ item }}
                    </p>
                  </div>
                </transition>
              </label>
              <div>
                <input class="btn" type="button" @click="search" value="搜索" />
                <input
                  style="color: #fff;background-color: #5B85FF;"
                  class="btn"
                  type="reset"
                  @click="reset"
                  value="重置"
                />
              </div>
            </div>
            <!-- 表格 -->
            <div class="table">
              <el-table
                :data="tableData"
                border
                size="medium"
                style="width: 100%"
              >
                <el-table-column
                  prop="userCode"
                  label="模拟账号"
                  width=""
                  height="48"
                >
                </el-table-column>
                <el-table-column prop="userCode" label="初始密码">
                </el-table-column>
                <el-table-column prop="company" label="申请机构">
                </el-table-column>
                <el-table-column prop="contactor" label="联系人">
                </el-table-column>
                <el-table-column prop="phone" label="联系电话">
                </el-table-column>
                <el-table-column
                  prop="initBalance"
                  label="初始规模"
                  width="142"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.initBalance | round }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="申请说明">
                </el-table-column>
                <el-table-column prop="state" label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.state == 1 ? true : false"
                    style="color: #181E2D;"
                      >已生效</span
                    >
                    <span
                      style="color: #F54836;"
                      v-if="scope.row.state == 3 ? true : false"
                      >已拒绝</span
                    >
                    <span
                    style="color: #FF7D26;"
                    v-if="scope.row.state == 0 ? true : false"
                    >待审批</span
                  >
                  <span
                  style="color: #475173;"
                  v-if="scope.row.state == 2 ? true : false"
                  >已冻结</span
                >
                  </template>
                </el-table-column>
                <el-table-column prop="timeDesc" label="有效期">
                </el-table-column>
                <el-table-column prop="isAdded" width='140' label="多账号交易列表"  align="center">
                  <template slot-scope="scope">
                    <span
                      v-if="
                        scope.row.isAdded && scope.row.state == 1 ? true : false
                      "
                      >已加入</span
                    >
                    <span
                      style="color: #949598"
                      v-if="scope.row.state != 1 ? true : false"
                      >无法加入</span
                    >
                    <span
                      @click="push(scope.row)"
                      style="color: #5B85FF;cursor: pointer;"
                      v-if="
                        scope.row.state == 1 && !scope.row.isAdded
                          ? true
                          : false
                      "
                      >加入</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 分页 -->
            <div class="page_box">
              <div class="msg_count">共&nbsp;{{ length?length:'0' }}&nbsp;条</div>
              <div class="blank"></div>
              <div class="page">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="pageLength ? pageLength : 0"
                  @next-click="addPage"
                  @prev-click="reducePage"
                  @current-change="currentPage"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <!-- 账户列表遮罩层 -->
      <div class="popContainer" v-show="show">
        <div class="add" :style="{ width: '640px' }">
          <span
            class="close iconfont icon-close_round_fill_bold
          "
            @click="cancel"
          ></span>
          <div class="Top" :style="{ width: '640px' }">
            申请模拟帐号
          </div>
          <div class="form_box" style="width: 100%;">
            <div class="form" style="width: 400px;margin-left:66px;height: 270px;">
              <label class="sim_laber" for="">
                <span> <i>*</i> 申请机构</span>
                <el-input
                  v-model="mechanism"
                  placeholder="填写申请账户的机构全称"
                ></el-input>
              </label>
              <label class="sim_laber" for="">
                <span> <i>*</i> 联系人</span>
                <el-input
                  v-model="contacts"
                  placeholder="请填写联系人姓名"
                ></el-input>
              </label>
              <label class="sim_laber" for="">
                <span> <i>*</i> 联系电话</span>
                <el-input v-model="r_phone" placeholder="请输入内容"></el-input>
              </label>
              <label class="sim_laber" for="">
                <span> <i>*</i> 初始规模</span>
                <el-input v-model="scale" placeholder="请输入内容"></el-input>
              </label>
              <label class="sim_laber" for="">
                <span> <i>*</i> 申请说明</span>
                <el-input
                  v-model="explain"
                  placeholder="简单说明账号用途，如量化测试"
                ></el-input>
              </label>
            </div>
          </div>
          <div class="form_btn" >
            <!-- <button   @click="cancel">取消</button> -->
            <button  @click="submit">提交</button>
   
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import hhead from '../../../components/header/index';
import nnav from '../../../components/nav/index';

import './style.css';
export default {
  name: 'simulation',
  components: { hhead, nnav },
  data() {
    return {
      focus_account1:'',
      focus_name1:'',
      accountAdd1:'',
      res: '',
      mechanism: '', //机构
      contacts: '', //联系人
      r_phone: '', //联系电话
      scale: 1000000.0, //初始规模
      explain: '', //申请说明
      type: '',
      yunCode: '',
      user_show: false,
      pwd_show: false,
      addYun: true,
      user: '',
      pwd: '',
      page: 1, //当前分页
      length: '', //账户列表总数
      pageLength: null, //账户列表分页长度
      consoleList: [], //控制台列表
      name_c: '1',
      account_c: '1',
      show: false,
      yunName: false,
      yunName_b: false,
      accountTypeShow: false,

      account: '',
      name: '',
      searchData: '',
      yun_name: '',
      accountType: '',
     
      
      tableData: [],
      accountTypeList: ['待审批', '已生效', '已冻结', '已拒绝'],
      MHeight: document.documentElement.clientHeight - 160 + 'px',
    };
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      let d = date.getDate();
      d = d < 10 ? '0' + d : d;
      let h = date.getHours();
      h = h < 10 ? '0' + h : h;
      let m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      let s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    renderTime: function(date) {
      var dateee = new Date(date).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
        .substr(0, 16);
    },
    round: function(num) {
      var result = [],
        counter = 0;
      num = (num || 0).toString().split('');
      for (var i = num.length - 1; i >= 0; i--) {
        counter++;
        result.unshift(num[i]);
        if (!(counter % 3) && i != 0) {
          result.unshift(',');
        }
      }

      return result.join('') + '.00';
    },
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if(this.$refs.mbMenu){

if (!this.$refs.mbMenu.contains(e.target)) {
// this.mb_menuVisible = false
  this.accountTypeShow = false
  this.accountAdd1 = ''
}
      }

})
  },
  created() {
    //获取多账户列表信息
    if (!this.type) {
      this.pageAxios(); //账户列表分页
      // this.$axios({
      //   //账户列表总条数 总分页
      //   method: 'post',
      //   url: '/cloud/sim_user/list',
      //   params: {
      //     page_no: 1,
      //     size: 10000,
      //     apiToken: this.$store.state.usermsg.apiToken,
      //   },
      // }).then((res) => {
      //   // console.log(res);
      //   if (res.data.code == 200) {
      //     this.length = res.data.data.length;
      //     this.pageLength = Math.ceil(res.data.data.length);

      //     res.data.data.some((item) => {
      //       // // console.log(item);
      //       if (item.state == 1) {
      //         // app.state = item
      //         // // console.log(app.state)
      //         this.mechanism = item.company;
      //         this.contacts = item.contactor;
      //         this.r_phone = item.phone;
      //         this.scale = item.initBalance;
      //         this.explain = item.remark;
      //       }
      //       return item.state == 1;
      //     });
      //   }
      //   // // console.log(this.tableData)
      // });
    }
    this.r_phone = this.$store.state.usermsg.phone;
  },
  computed: {},
  methods: {
    push(res) {
      //加入多账户交易列表
      if (!res.isAdded) {
        this.$confirm(
          `您确定添加模拟帐号“${res.userCode}”至多账号交易端帐号列表么？`,
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true,
          }
        ).then(() => {
          this.$axios
            .post('/cloud/sim_user/save_to_list', {
              id: res.id,
              apiToken: this.$store.state.usermsg.apiToken,
            })
            .then((result) => {
              // console.log(res);
              this.tokenInvalid(result)
              if (result.data.code == 200) {
                    this.pageAxios();
                    this.$alert(result.data.message, {
                        confirmButtonText: '确定',
                        type: 'success',
                        center: true,
                    })
                        .then(() => { })
                        .catch(() => { });
              }else{
                this.$alert(result.data.message, {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true,
                    })
                        .then(() => { })
                        .catch(() => { });
              }
            })
            .catch((err) => {
              // console.log(err);
            });
        }).catch(() => {
           
            })
        
      }
      // if(!isAdded){
      // 	let app = this
      // 	Dialog.confirm({
      // 	  message: `您确定添加模拟帐号“${app.res.userCode}”至多账号交易端帐号列表么？`,
      // 	})
      // 	  .then(() => {
      // 	    app.$api.SEND(
      // 	    '/user/sim_user/save_to_list',
      // 	    'get',
      // 	    {id:app.id,apiToken:app.user.apiToken},
      // 	    res=>{
      // 	    	// console.log(res)
      // 			if(res.data.code == 200){
      // 				app.res.isAdded=true
      // 				Dialog.alert({
      // 				  message: res.data.message,
      // 				}).then(() => {
      // 				  // on close
      // 				});
      // 			}
      // 	    },
      // 	    err=>{
      // 	    	// console.log(err)
      // 	    }
      // 	    )
      // 	  })
      // 	  .catch(() => {
      // 	    // on cancel
      // 	  });
      // }
    },
    pageAxios() {
      var state_ = '';
      if (this.accountType == '已拒绝') {
              state_ = '3';
            } else if (this.accountType == '待审批') {
              state_ = '0';
            } else if (this.accountType == '已生效') {
              state_ = '1';
            }else if (this.accountType == '已冻结') {
              state_ = '2';
            }
            this.$axios({
        method: 'post',
        url: '/cloud/sim_user/list',
        params: {
          page_no: 1,
          size: 1000,
          userCode:this.account,
          state:state_,
          company:this.name,
          apiToken: this.$store.state.usermsg.apiToken,
        },
      }).then(result=>{
        this.length = result.data.data.length;
        this.pageLength = Math.ceil(result.data.data.length);
      })   
      
      
      this.$axios({
        method: 'post',
        url: '/cloud/sim_user/list',
        params: {
          page_no: this.page,
          size: 10,
          userCode:this.account,
          state:state_,
          company:this.name,
          apiToken: this.$store.state.usermsg.apiToken,
        },
      }).then((res) => {
        // console.log(res);
        this.tokenInvalid(res)
        if (res.data.code == 200) {
          this.tableData = res.data.data;
        }
        // // console.log(this.tableData)
      });
    },
    addPage(e) {
      //分页 下一页
      //  this.page = e
      //  // console.log(this.page)
    },
    reducePage(e) {
      //上一页
      // this.page = e
      // // console.log(this.page)
    },
    currentPage(e) {
      //当前页
      this.page = e;
      this.pageAxios();
      // console.log(this.page);
    },

    added() {
      //添加按钮
      this.show = true;
    },
    yun(e) {
      //私有云名称按钮

      this.yunName = !this.yunName;
    },
    yun_b() {
      this.yunName_b = !this.yunName_b;
    },
    accountAdd() {
      //账户类型按钮
      this.accountAdd1 = '1px solid #7195FF'
      this.accountTypeShow = !this.accountTypeShow;
    },

    focus_account() {
      //账户输入框聚焦
      this.focus_account1 = '1px solid #7195FF'
      this.err_show = false;
    },
    focus_name() {
      //姓名输入框聚焦
      this.err_show1 = false;
      this.focus_name1 = '1px solid #7195FF'
    },
    blur_account() {
      //账户输入框失焦
      this.err_show = true;
      this.focus_account1 = ''
    },
    blur_name() {
      //姓名输入框失焦
      this.err_show1 = true;
      this.focus_name1 = ''
    },
    reset() {
      //重置按钮
      this.account = '';
      this.name = '';
      this.accountType = '';
      this.yun_name = '私有云名称';
      this.search()
    },
    accountTypeAdd(item) {
      //选择账户类型
      this.accountType = item;
      this.accountTypeShow = false;
      this.accountAdd1 = ''
    },
    cancel() {
      this.show = false;
      this.mechanism = '';
      // this.r_phone = '';
      this.contacts = '';
      // this.scale = '';
      this.explain = '';
    },
    inp_blurUser() {
      this.accountTypeShow = false;
    },
    inp_blur() {
      this.yunName = false;
    },
    inp_blur_b() {
      this.yunName_b = false;
    },
    submit() {
      if (
        this.mechanism &&
        this.r_phone &&
        this.contacts &&
        this.scale &&
        this.explain
      ) {
        this.$axios
          .post('/cloud/sim_user/saveNew', {
            apiToken: this.$store.state.usermsg.apiToken,
            company: this.mechanism,
            contactor: this.contacts,
            remark: this.explain,
            phone: this.r_phone,
            initBalance: this.scale,
          })
          .then((res) => {
            // console.log(res);
            this.tokenInvalid(res)
            if (res.data.code == 200) {
              this.cancel();
              this.pageAxios();
            }else if(res.data.code == 100){
                this.$confirm(`恭喜您的申请已经自动审核通过。您可以在模拟测试-》测试下载里面下载模拟交易端或者量化对接接口`, {
                    confirmButtonText: '立即下载',
                    cancelButtonText: '取消',
                  
                    type: 'success',
                    center:true
                }).then(res=>{
                    this.$router.push('/user/sim_user/download')
                }).catch(err=>{
                    this.cancel();
              this.pageAxios();
                })
            }
             else {
               
                this.$alert(res.data.message, {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true,
                    })
                        .then(() => { })
                        .catch(() => { });
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      } else {
        this.$alert('请填写正确的信息', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true,
                    })
                        .then(() => { })
                        .catch(() => { });
      }
    },

    user_blur() {
      if (this.user.length == 0) {
        this.user_show = true;
      } else {
        this.user_show = false;
      }
    },
    pwd_blur() {
      if (this.pwd.length == 0) {
        this.pwd_show = true;
      } else {
        this.pwd_show = false;
      }
    },

    search() {
      this.pageAxios()
    },
  },
  watch: {
    account() {
      //监听账户输入框
      if (this.account.length > 0) {
        this.err_show = true;
      }
    },
    name() {
      //监听账户
      if (this.name.length > 0) {
        this.err_show1 = true;
      }
    },
    name_c() {
      // console.log(this.name_c);
      if (this.name_c == 1) {
        this.addYun = true;
      }
      if (this.name_c == 0) {
        this.addYun = false;
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/view/user/simulation/index.vue